"use client";

import { c as _c } from "react/compiler-runtime";
import { init, onMetrixUserIdReceived, subscribePush } from "@metrixorg/websdk";
import { isChannel } from "@website/utils/channel/helpers";
import { useEffect } from "react";
export const Metrix = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
  return null;
};
function _temp() {
  subscribePush();
}
function _temp2() {
  if (!isChannel(["android"])) {
    return;
  }
  init("ackcrxjytpuhtry", "c78c8d9e-7115-47f1-870d-09fd3f9c1329", {
    sessionTracking: {
      enabled: true,
      packageName: "com.pintapin.pintapin"
    },
    onSiteMessaging: {
      enabled: true
    },
    push: {
      enabled: true,
      publicKey: "BM_h1-9yFK-qAfb_89Pn4T2mDstUiYThjrOid2PhGCXobs9CKVQ1hgYTXg4Up59pZUhMltBQPIZFYvgkzvi61F0",
      hasSW: false
    }
  });
  onMetrixUserIdReceived().then(_temp);
}